/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Autocomplete,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import { DatePicker } from '@mui/x-date-pickers';
import LinearWithValueLabel from '../MuiProgress/LinearProgressWithLabel';
import { getDCR } from '../../api/reportsApi';
import AppConst from '../AppLayout/const';
import { getDepartmentFilter } from '../../api/filterOptionsApi';
import { filterDepartmentOptions } from '../../helpers/filterFunctions';

export default function DCRModal() {
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [progress, setProgress] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [toggle, setToggle] = useState(false);

  const defaultFilter = {
    department: { label: 'ALL', value: null },
  };

  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [departmentOptions, setDepartmentDrowndown] = useState([]);
  const [fromValue, setFromValue] = useState(moment().format('YYYY-MM-DD'));
  const [toValue, setToValue] = useState(moment().format('YYYY-MM-DD'));

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const loadDepartmentDropdown = async () => {
    const request = {
      keyword: '',
    };
    const reponse = await getDepartmentFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterDepartmentOptions(data);

      setDepartmentDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  useEffect(() => {
    if (toggleModal?.url === 'report/dcr') {
      setToggle(true);
      loadDepartmentDropdown();
    }
  }, [toggleModal]);

  const downloadFile = (result) =>
    new Promise((resolve) => {
      const link = document.createElement('a');
      link.href = result.file;
      link.download = result.file_name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(`Successfully exported file: ${result.file_name}`);
      setTimeout(() => resolve(), 2000);
    });

  const handleExport = async () => {
    try {
      toast.loading('Please wait ...');
      const res = await getDCR({
        from: fromValue,
        to: toValue,
        department: filterForm.department.value,
      });

      const { code, result, message } = res.data.response;
      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();
      // for (let i = 0; i < result.length; i += chunkSize) {
      //   // const chunk = result.slice(i, i + chunkSize);

      //   // console.log(`Processing chunk ${i / chunkSize + 1}:`, chunk);
      //   // console.log('progress count', Math.min(((i + chunkSize) / result.length) * 100, 100));

      //   // chunk?.map((row) => {
      //   //   window.open(row.file);
      //   //   toast.success(`Sucessfully exported file: ${row.file_name}`);
      //   //   console.log(`Sucessfully exported file: ${row.file_name}`);

      //   //   return 1;
      //   // });

      //   // setProgress(Math.min(((i + chunkSize) / result.length) * 100, 100));
      // }
      setDownloading(true);
      /* eslint-disable no-await-in-loop */
      /* eslint-disable no-plusplus */
      for (let i = 0; i < result.length; i++) {
        await downloadFile(result[i]);
        setProgress(((i + 1) / result.length) * 100);
      }
      setInterval(() => {
        setDownloading(false);
        setProgress(0);
      }, 5000);
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleSubmit = () => {
    handleExport(fromValue, toValue);
  };

  const handleChangeFrom = (value) => {
    setFromValue(moment(value).format('YYYY-MM-DD'));
  };

  const handleChangeTo = (value) => {
    setToValue(moment(value).format('YYYY-MM-DD'));
  };

  const handleCancel = () => {
    onToggleModal(null);
    setToggle(false);
  };

  return (
    <Dialog open={toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Daily Call Report Report</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid md={12}>
            <Autocomplete
              disablePortal={false}
              id='department'
              disableClearable
              fullWidth
              options={departmentOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Deparment' />}
              size='small'
              value={filterForm?.department}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
          <Grid xs={6}>
            <DatePicker
              label='from'
              views={['month', 'day', 'year']}
              value={fromValue}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='From' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeFrom(value)}
            />
          </Grid>
          <Grid xs={6}>
            <DatePicker
              label='to'
              views={['month', 'day', 'year']}
              value={toValue}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='To' size='small' fullWidth />}
              onChange={(value) => handleChangeTo(value)}
            />
          </Grid>
          {progress > 0 && downloading ? (
            <Grid md={12}>
              <LinearWithValueLabel value={progress} />
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit}>Submit</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
